import styled from "styled-components";
import { Route, Routes } from "react-router-dom";

import ContentsList from "./MainContent/ContentsList";
import CategoryList from "./MainContent/CategoryList";
import TagList from "./MainContent/TagList";
import PositionList from "./MainContent/PositionList";
import ReferenceList from "./MainContent/ReferenceList";
import SideMenu from "./SideMenu";
import AffiliateList from "./MainContent/AffiliateList";

const Container = styled.div`
  height: 100vh;
`;

const MainContent = styled.div`
  height: 100%;
  margin-left: 200px;
  padding: 20px;
  box-sizing: border-box;
`;

const StyledSideMenu = styled.nav`
  top: 0;
  left: 0;
  width: 200px;
  height: 100%;
  background-color: #f0f0f0;
  padding: 10px;
  position: fixed;
  box-sizing: border-box;
`;

export const TableContent = styled.div`
  width: 100%;
  height: 80vh;
  overflow: auto;
`;

export const Table = styled.table`
  width: auto;
  border-collapse: collapse;

  th {
    position: sticky;
    top: 0;
    text-align: left;
    background-color: #e0e0e0;
    z-index: 2;
  }

  th,
  td {
    padding: 10px;
    min-width: 150px;
    border-bottom: 1px solid #ddd;
  }

  th:last-child,
  td:last-child {
    position: sticky;
    right: 0;
  }

  td:last-child {
    background-color: whitesmoke;
    z-index: 1;
  }
`;

export const TdLong = styled.td`
  min-width: 300px !important;
`;

const Admin = () => {
  return (
    <Container>
      <StyledSideMenu>
        <SideMenu />
      </StyledSideMenu>
      <MainContent>
        <Routes>
          <Route path="contents-list" element={<ContentsList />} />
          <Route path="category-list" element={<CategoryList />} />
          <Route path="tag-list" element={<TagList />} />
          <Route path="position-list" element={<PositionList />} />
          <Route path="reference-list" element={<ReferenceList />} />
          <Route path="affiliate-list" element={<AffiliateList />} />
        </Routes>
      </MainContent>
    </Container>
  );
};

export default Admin;
